'use client';

import { ClipboardIcon } from '@/components/icons';
import { useHasRole } from '@/hooks/useCurrentUserRoles';
import NavIconLink from './NavIconLink';

export default function ManageDropdown() {
  const { hasRole: isSaxUser, isLoading: saxLoading } = useHasRole('Sax');

  if (saxLoading || !isSaxUser) {
    return null;
  }

  return (
    <NavIconLink href="/admin/manage" label="Manage">
      <ClipboardIcon className="h-6 w-6" />
    </NavIconLink>
  );
}
